














import { defineComponent } from '@vue/composition-api';
import NewFeatureBadge from '@tt4b/ttam-assets/src/svgs/new-feature-badge.svg';

const name = 'ttam-new-feature-badge';
export default defineComponent({
  name,
  components: {
    BadgeIcon: NewFeatureBadge,
  },
  props: {
    hintText: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
